import { render, staticRenderFns } from "./_base-place-holder-grid.vue?vue&type=template&id=2c055ff4&"
import script from "./_base-place-holder-grid.vue?vue&type=script&lang=ts&"
export * from "./_base-place-holder-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports